import { render, staticRenderFns } from "./priorityLists.vue?vue&type=template&id=8081b1d8&scoped=true&"
import script from "./priorityLists.vue?vue&type=script&lang=js&"
export * from "./priorityLists.vue?vue&type=script&lang=js&"
import style0 from "./priorityLists.vue?vue&type=style&index=0&id=8081b1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8081b1d8",
  null
  
)

export default component.exports